import { createPopper } from './popper'
import dragToScroll from './dragtoscroll'
/**
 * Class Map Marker
 * (marker + popup)
 */
export default class MapMarker {
  constructor (mapid, optionsPopup = {}) {
    this.map = document.querySelector(mapid)

    if (this.map) {
      this.popperInstance = null
      this.markerAttribe = 'data-map-marker'
      this.currentPopup = null
      this.currentMarker = null
      this.optionsPopup = {
        placement: 'top',
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, 20]
            }
          }
        ]
      }
      // init dragScrool to map
      // eslint-disable-next-line new-cap
      new dragToScroll(this.map)

      this.plan = this.map.querySelector('.interactivemap__container')

      this.optionsPopup = { ...this.optionsPopup, ...optionsPopup }

      // this.plan.addEventListener('click', e => {
      //   e.preventDefault()
      //   if (e.target === this.plan) {
      //     this.hide()
      //     this.currentPopup = null
      //   }
      // })

      this.markers = this.map.querySelectorAll(`[${this.markerAttribe}]`)

      if (this.markers) {
        this.markers.forEach(marker => {
          marker.addEventListener('click', (e) => {
            e.preventDefault()
            e.stopPropagation()

            const popup = this.map.querySelector(marker.getAttribute('data-popup-target'))
            this.hide()
            if (popup !== this.currentPopup) {
              this.show(marker, popup)
            } else {
              this.hide()
              this.currentPopup = null
            }
          })
        })
      }
    }
  }

/**
 * hide popper
 */
  hide () {
    if (this.popperInstance) {
      this.popperInstance.destroy()
      if (this.currentMarker) this.currentMarker.classList.remove('is-active')
      if (this.currentPopup) this.currentPopup.classList.remove('is-show')
    }
  }

  /**
   * show poper
   * @param {*} marker
   * @param {*} popup
   */
  show (marker, popup) {
    marker.classList.add('is-active')
    this.currentMarker = marker
    this.popperInstance = createPopper(marker, popup, {
      placement: 'top',
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: [0, 20]
          }
        }
      ]
    })
    popup.classList.add('is-show')
    this.popperInstance.update()
    this.currentPopup = popup
  }
}
